const STORAGE_KEY_PREFIX = "lca_product_unit_image:";

/**
 * The real product/sales-unit API (`api/product.ts`) has no image field or
 * upload endpoint for a sales unit — only the product itself supports an
 * image. Per-unit images (required by the ticket/prototype but not backed by
 * the server) are therefore stored client-side, keyed by the unit's real,
 * server-issued `_id`. Not sent to the API, and not shared across browsers.
 */
export const getSalesUnitImage = (unitId: string): string | null => {
  try {
    return localStorage.getItem(`${STORAGE_KEY_PREFIX}${unitId}`);
  } catch {
    return null;
  }
};

export const setSalesUnitImage = (unitId: string, dataUrl: string): void => {
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${unitId}`, dataUrl);
  } catch {
    // Storage unavailable/full — the image simply won't persist across reloads.
  }
};

export const removeSalesUnitImage = (unitId: string): void => {
  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${unitId}`);
  } catch {
    // no-op
  }
};

export const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
